import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon } from 'lucide-react';
import { Reveal } from '../ui/Reveal';
import { IMAGES } from '../../data/images';
import { useLanguage } from '../../i18n/LanguageContext';
export function CompanyOverview() {
  const {
    t
  } = useLanguage();
  return <section className="w-full bg-white py-24 lg:py-32" aria-labelledby="overview-title" data-id="element-101" data-mp="j9qlesxal5ty">
      <div className="mx-auto grid max-w-container items-center gap-16 px-6 lg:grid-cols-2 lg:gap-24" data-id="element-102" data-mp="1fzq2xcvf7eoo">
        <Reveal data-id="element-103" data-mp="1bxczww825uvl">
          <div className="relative" data-id="element-104" data-mp="1byo0kn67imih">
            <div className="absolute -left-4 -top-4 h-24 w-24 rounded-tl-3xl border-l border-t border-gold/40" aria-hidden="true" data-id="element-105" data-mp="1bvigjmcfqatm" />
            <img src={IMAGES.boardroom} alt={t.overview.imageAlt} className="relative w-full rounded-3xl object-cover shadow-lift" data-id="element-106" data-mp="11yx80r17ihl1" />
            <div className="absolute -bottom-8 -right-4 hidden rounded-2xl bg-navy px-8 py-6 shadow-lift sm:block" data-id="element-107" data-mp="3momot9lh0dgd">
              <p className="font-display text-3xl font-medium text-gold-light" data-id="element-108" data-mp="k3yf34mc4n2x">
                {t.overview.statValue}
              </p>
              <p className="mt-1 text-[10px] uppercase tracking-widest2 text-navy-100/60" data-id="element-109" data-mp="a596y3k8qgzv">
                {t.overview.statLabel}
              </p>
            </div>
          </div>
        </Reveal>

        <Reveal delay={0.1} data-id="element-110" data-mp="fhaf3skzdsr">
          <div className="flex items-center gap-4" data-id="element-111" data-mp="f7hp8g5isjd">
            <span className="rule-gold" aria-hidden="true" data-id="element-112" data-mp="dczw306fgji" />
            <p className="eyebrow text-gold-dark" data-id="element-113" data-mp="56zc5u2fhies">{t.overview.eyebrow}</p>
          </div>
          <h2 id="overview-title" className="mt-5 font-display text-3xl font-medium leading-[1.15] text-navy sm:text-4xl lg:text-[2.75rem]" data-id="element-114" data-mp="3nl88vgu90iqk">
            {t.overview.title}
          </h2>
          <div className="mt-6 space-y-5 text-base leading-relaxed text-charcoal-light" data-id="element-115" data-mp="3dmj2olbpsmq5">
            {t.overview.paragraphs.map(paragraph => <p key={paragraph.slice(0, 32)} data-id="element-116" data-mp="2zg7bdumlbbuu">{paragraph}</p>)}
          </div>
          <Link to="/about" className="group mt-10 inline-flex items-center gap-2 text-[12px] font-semibold uppercase tracking-[0.16em] text-navy transition-colors hover:text-gold-dark" data-id="element-117" data-mp="2upqx68ay3m7f">
            {t.overview.link}
            <ArrowRightIcon className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" aria-hidden="true" data-id="element-118" data-mp="2ksvxhm2xrfrk" />
          </Link>
        </Reveal>
      </div>
    </section>;
}